import { Field, Label, ErrorMessage } from "V2.0/common/fieldset";
import { Input } from "V2.0/common/input";
import { Listbox, ListboxOption, ListboxLabel } from "V2.0/common/listbox";
import { Textarea } from "V2.0/common/textarea";
import Headers from "./Headers";
import QueryParams from "./QueryParams";
import Body from "./Body";

export default ExternalApiForm;

const apiMethods = [
  { id: 0, value: "GET", label: "GET" },
  { id: 1, value: "POST", label: "POST" },
  { id: 2, value: "PUT", label: "PUT" },
  { id: 3, value: "PATCH", label: "PATCH" },
  { id: 4, value: "DELETE", label: "DELETE" },
];

function ExternalApiForm(props) {
  const { formState, updateFormState, errors } = props;

  const showBody = ["POST", "PUT", "PATCH"].includes(formState.method);

  return (
    <div className="flex flex-col gap-y-6">
      <Field>
        <Label>Name *</Label>
        <Input
          type="text"
          value={formState.name}
          onChange={(e) => updateFormState("name", e.target.value)}
          invalid={!!errors.name}
        />
        {errors.name && <ErrorMessage>{errors.name}</ErrorMessage>}
      </Field>

      <Field>
        <Label>Description</Label>
        <Textarea
          value={formState.description}
          rows={3}
          style={{ fontSize: "13px" }}
          onChange={(e) => updateFormState("description", e.target.value)}
        />
      </Field>

      <Field>
        <Label>Method *</Label>
        <Listbox
          as="div"
          className="my-4"
          value={formState.method}
          defaultValue={formState.method}
          onChange={(value) => updateFormState("method", value)}
        >
          {apiMethods.map((method) => (
            <ListboxOption
              key={method.id}
              value={method.value}
            >
              <ListboxLabel>{method.label}</ListboxLabel>
            </ListboxOption>
          ))}
        </Listbox>
      </Field>

      <Field>
        <Label>URL *</Label>
        <Input
          type="text"
          value={formState.url}
          onChange={(e) => updateFormState("url", e.target.value)}
          invalid={!!errors.url}
        />
        {errors.url && <ErrorMessage>{errors.url}</ErrorMessage>}
      </Field>

      <Headers
        headers={formState.headers}
        onUpdate={(headers) => updateFormState("headers", headers)}
      />

      <QueryParams
        queryParams={formState.queryParams}
        onUpdate={(queryParams) => updateFormState("queryParams", queryParams)}
      />

      {showBody && (
        <Body
          body={formState.body}
          onUpdate={(body) => updateFormState("body", body)}
        />
      )}
    </div>
  );
}
